import { SET_GLOBAL_REPAIR_SERVICES } from './actionTypes';

export const setGlobalRepairServices = services => ({
  type: SET_GLOBAL_REPAIR_SERVICES,
  payload: services
});



// WEBPACK FOOTER //
// ./src/store/reducers/globalRepair/actions.js